import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useBrand } from '../../contexts/BrandContext';

/**
 * The quietest section on the site, and its emotional centre. One specific moment
 * almost every woman in this audience recognises, rather than a general claim of empathy.
 */
export function NightBand() {
  const {
    brand
  } = useBrand();
  return <section className="bg-plum text-cream-light" aria-labelledby="night-heading" data-id="element-216" data-mp="3gzfwk3pxxkwj">
      <div className="mx-auto grid max-w-shell gap-12 px-6 py-20 md:px-8 md:py-28 lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-20" data-id="element-217" data-mp="3lxr7khrz21gc">
        <div data-id="element-218" data-mp="3qwavgnq4lnbc">
          <p className="text-[0.6875rem] uppercase tracking-label text-blush" data-id="element-219" data-mp="3qvj1tig39znp">3:14am</p>
          <h2 id="night-heading" className="mt-6 max-w-xl font-serif text-4xl italic leading-[1.05] md:text-[3.5rem]" data-id="element-220" data-mp="3uzgy7le14wd2">
            It’s 3am and you’re awake again.
          </h2>
          <p className="mt-8 max-w-xl text-lg leading-relaxed text-cream/80" data-id="element-221" data-mp="1a6n9pvh3dmmb">
            Your heart is going. The sheets are damp. You are doing the arithmetic on how many hours
            are left and how you will get through tomorrow, and you have been doing this most nights
            for months.
          </p>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-cream/80" data-id="element-222" data-mp="215xl5ezibxu6">
            There is a mechanism behind it. Progesterone is sedating, and it is the first hormone to
            fall. Add an early-hours cortisol rise and a temperature surge, and you wake at almost
            exactly the same time every night. Being told to try lavender is not treatment.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:flex-wrap" data-id="element-223" data-mp="1iduzfp80drd2">
            <Link to="/library/rage" className="group inline-flex items-center gap-2 rounded-brand border border-blush/45 px-6 py-3 text-sm font-medium text-cream-light transition-colors duration-150 ease-brand hover:bg-blush hover:text-plum" data-id="element-224" data-mp="1dftf70yujm00">
              What’s happening in your body right now
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-brand group-hover:translate-x-1" aria-hidden="true" data-id="element-225" data-mp="uskkw27huhan" />
            </Link>
            <Link to="/care/sleep-mood-fog" className="inline-flex items-center rounded-brand border border-cream/25 px-6 py-3 text-sm font-medium text-cream/85 transition-colors duration-150 ease-brand hover:border-cream/60 hover:text-cream" data-id="element-226" data-mp="pr3pgm7s3n1g">
              The sleep, mood and fog care path
            </Link>
          </div>

          <div className="rule-plum mt-10 pt-6" data-id="element-227" data-mp="13qml4fjel5wv">
            <Link to="/circles" className="text-sm text-blush underline-offset-4 hover:underline" data-id="element-228" data-mp="18pfwo2f4qmue">
              Or open the 3am thread — other women are awake right now too.
            </Link>
          </div>
        </div>

        <img src={brand.images.night} alt="A woman sitting on the edge of a bed in the middle of the night, lit by a single lamp." className="h-full max-h-[30rem] w-full rounded-brand object-cover" loading="lazy" data-id="element-229" data-mp="217br8lfdyuc2" />
      </div>
    </section>;
}